export const BRAND = {
    name: 'Televicentro',
    descriptor: 'Cine & Televisión',
    legalName: 'Televicentro del Valle S.A.S.',
    taxId: '890.328.298-6',
    city: 'Cali, Colombia',
    foundingYear: 1985,
};

export const WHATSAPP_NUMBER = '573006108432';

export const WHATSAPP_MESSAGES = {
    quote: 'Hola, quiero cotizar un proyecto con Televicentro',
    rental: 'Hola, quiero consultar disponibilidad y tarifas de alquiler de equipos',
};

export const CONTACT = {
    whatsappDisplay: '+57 300 610 8432',
    phones: [
        { display: '+57 316 291 5361', href: 'tel:+573162915361' },
        { display: '(602) 334 6183', href: 'tel:+576023346183' },
    ],
    email: 'televicentrocali@yahoo.es',
    address: 'Carrera 32 #10A-56, barrio Colseguros',
    addressCity: 'Santiago de Cali, Valle del Cauca',
    mapsHref: 'https://maps.google.com/maps?q=Carrera+32+10+a+56+colseguros%2C+Santiago+de+Cali%2C+Colombia',
    hours: 'Lunes a viernes, 8:00 a.m. – 6:00 p.m.',
    // The client has not confirmed opening hours yet; the UI flags the value while this is false.
    isHoursConfirmed: false,
};

export const SOCIAL_LINKS = [
    { id: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/televicentro_pro/' },
    { id: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/televicentro.cineytv/' },
    { id: 'youtube', label: 'YouTube', href: 'https://www.youtube.com/@televicentrodelvalle' },
    { id: 'linkedin', label: 'LinkedIn', href: 'https://co.linkedin.com/company/televicentro-del-valle' },
];

export const NAV_LINKS = [
    { label: 'Servicios', href: '/#servicios' },
    { label: 'Equipos', href: '/#equipos' },
    { label: 'Trayectoria', href: '/#trayectoria' },
    { label: 'Contacto', href: '/#contacto' },
];

export const PRIVACY_POLICY_PATH = '/politica-de-datos.html';

// Leave href empty to render the credit as plain text; the agency URL is still to be confirmed.
export const AGENCY_CREDIT = {
    label: 'Trianametria Software',
    href: '',
};
